import React from "react";
import { FooterContainer } from "./styled";

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <p>
        Free For Everyone
      </p>
    </FooterContainer>
  );
};

export default Footer;
